// Vendors
import { BreakpointsEnum, MiscellaneousUserAgentsEnum, MiscellaneousVendorsEnum } from '@openbank/ziniaweb-ui-core-models';
// Constants
import constants from './constants/devices.constants';
// Utilities
import { getAppLocale } from '../locale/locale.utils';
const viewportWidth = () => window.innerWidth || document.documentElement?.clientWidth || document.body?.clientWidth || 0;
const createV4Uuid = () => constants.V4_ID_PATTERN.replace(constants.V4_ID_REGEX, (c) => {
    const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
});
const getDeviceLoginParams = ({ deviceUUID = createV4Uuid(), ...rest }) => ({
    deviceInformation: {
        ...rest,
        deviceUUID,
        webDeviceInfo: {
            version: navigator.userAgent,
        },
    },
    language: getAppLocale(),
});
const isSafariNativeBrowser = () => window.navigator?.vendor?.indexOf(MiscellaneousVendorsEnum.APPLE) > -1 &&
    window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.APPLE_WEBKIT) > -1;
const isChromeBrowser = () => window.navigator?.vendor?.indexOf(MiscellaneousVendorsEnum.GOOGLE) > -1 &&
    window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.APPLE_WEBKIT) > -1;
const isAndroidNativeBrowser = () => window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.APPLE_WEBKIT) > -1 &&
    window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.ANDROID) > -1 &&
    window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.CHROME) <= -1 &&
    window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.MOZILLA) > -1;
const isMobileDevice = () => viewportWidth() < BreakpointsEnum.MOBILE - 1;
const isTabletDevice = () => viewportWidth() >= BreakpointsEnum.MOBILE && viewportWidth() <= BreakpointsEnum.TABLET;
const isMobileBrowserDevice = () => {
    return [
        MiscellaneousUserAgentsEnum.ANDROID,
        MiscellaneousUserAgentsEnum.IPHONE,
        MiscellaneousUserAgentsEnum.IPAD,
        MiscellaneousUserAgentsEnum.MOBI,
    ].some(device => window.navigator.userAgent.indexOf(device) > -1);
};
const isAndroidDevice = () => {
    return window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.ANDROID) > -1;
};
const isIOSDevice = () => {
    return [MiscellaneousUserAgentsEnum.IPHONE, MiscellaneousUserAgentsEnum.IPAD].some(device => window.navigator.userAgent.indexOf(device) > -1);
};
const isDesktopDevice = () => {
    let check = false;
    (function (a) {
        if (constants.DEVICE_VALIDATOR.test(a)) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor);
    return !check;
};
const isIOSWebview = () => {
    const ua = window.navigator.userAgent;
    const isIOS = /iP(ad|hone|od)/.test(ua);
    const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua);
    const isStandalone = window.navigator.standalone;
    // Safari in-app no tiene 'standalone' y suele tener 'Safari' en el UA
    return isIOS && isSafari && !isStandalone;
};
const isAndroidWebview = () => 
// Android WebView suele incluir "; wv" o "Version/X.X Chrome/"
/\bwv\b/.test(window.navigator.userAgent) || /Version\/[\d.]+ Chrome\/[\d.]+ Mobile/.test(window.navigator.userAgent);
const currentFrameIsNotTop = () => window.self !== window.top; // No estar en el top frame (puede ser iframe o WebView embebido)
const navigatorCanBeStandalone = () => window.navigator.standalone === true; // Algunos WebView no permiten acceso a localStorage o tienen window.navigator.standalone
const isHybridCommercialFramework = () => /Cordova|Capacitor|ReactNative/i.test(window.navigator.userAgent);
const isLikelyWebViewDevice = () => isIOSWebview() || isAndroidWebview() || currentFrameIsNotTop() || navigatorCanBeStandalone() || isHybridCommercialFramework();
export { createV4Uuid, currentFrameIsNotTop, getDeviceLoginParams, isAndroidWebview, isAndroidNativeBrowser, isChromeBrowser, isHybridCommercialFramework, isLikelyWebViewDevice, isMobileDevice, isIOSWebview, isSafariNativeBrowser, isTabletDevice, isDesktopDevice, isMobileBrowserDevice, isAndroidDevice, isIOSDevice, navigatorCanBeStandalone, viewportWidth, };
//# sourceMappingURL=devices.utils.js.map